import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PendingLoanState } from "../../types";
import { PendingLoanRequest } from "../../../utils/types";
import { axiosObj } from "../../../config/apiClients";

const initialState: PendingLoanState = {
  isLoading: false,
  requests: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllLoanRequests = createAsyncThunk(
  "/loanRequest/getAll",
  async ({ paramPage, paramLimit }: { paramPage: number; paramLimit: number }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get(
        `/loanRequest/getAll?paramPage=${paramPage}&paramLimit=${paramLimit}`);

      return response.data
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Requests' });
    }
  }
)

export const updateLoanRequestStatus = createAsyncThunk(
  "/loanRequest/status/update",
  async ({ id, loanStatus }: { id: string; loanStatus: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/loanRequest/status/update', { id, loanStatus });

      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Requests' });
    }
  }
);

const pendingLoanSlice = createSlice({
  name: "LoanRequest",
  initialState,
  reducers: {
    updateRequestStatus: (state, action) => {
      const requestStatus = action.payload;
      const request = state.requests.find((request) => request._id === requestStatus.id)
      if (request) {
        request.loanStatus = requestStatus.loanStatus;
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getAllLoanRequests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllLoanRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.payload.page === 1) {
          state.requests = action.payload.payload.allLoanRequests;
        } else {
          const existingBranches = new Map(state.requests.map(r => [r._id, r]));
          action.payload.payload.allLoanRequests.forEach((newRequest: PendingLoanRequest) => {
            if (!existingBranches.has(newRequest._id)) {
              state.requests.push(newRequest);
            }
          });
        }
        state.pagination = {
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllLoanRequests.rejected, (state) => {
        state.isLoading = false;
        state.requests = []
      })
      .addCase(updateLoanRequestStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateLoanRequestStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateLoanRequestStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
})

export const { updateRequestStatus } = pendingLoanSlice.actions;

export default pendingLoanSlice.reducer;